import * as fulfilmentLocationActionTypes from "./fulfilmentLocationTypes";

const initialState = {
  createdFulfilmentLocation: null,
  updatedFulfilmentLocation: null,
  fulfilmentLocations: [],
  loading: false,
};

const fulfilmentLocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case fulfilmentLocationActionTypes.CREATE_FULFILMENT_LOCATION:
      return {
        ...state,
        createdFulfilmentLocation: action.value,
      };
    case fulfilmentLocationActionTypes.UPDATE_FULFILMENT_LOCATION:
      return {
        ...state,
        updatedFulfilmentLocation: action.value,
        fulfilmentLocations: state.fulfilmentLocations.map(location =>
          location._id === action.value._id ? action.value : location
        ),
      };
    case fulfilmentLocationActionTypes.SET_Fulfilment_LOCATIONS:
      return {
        ...state,
        fulfilmentLocations: action.value,
      };
    default:
      return state;
  }
};

export default fulfilmentLocationReducer;